/**
 * Purpose: Map getUserMedia / camera DOMExceptions to stable reason codes.
 * Inputs: Caught errors from stream start failures.
 * Outputs: `CameraFailureReason` enum-like union.
 */

export type CameraFailureReason =
  | 'permission_denied'
  | 'camera_unavailable'
  | 'camera_in_use'
  | 'no_camera'
  | 'constraints_unsatisfied'

/** Maps a rejected `getUserMedia` to a closed reason set. */
export function cameraFailureReason(err: unknown): CameraFailureReason {
  const name = err instanceof Error ? err.name : ''
  if (name === 'NotAllowedError' || name === 'PermissionDeniedError') {
    return 'permission_denied'
  }
  if (name === 'NotReadableError' || name === 'TrackStartError') {
    return 'camera_in_use'
  }
  if (name === 'NotFoundError' || name === 'DevicesNotFoundError') {
    return 'no_camera'
  }
  if (name === 'OverconstrainedError' || name === 'ConstraintNotSatisfiedError') {
    return 'constraints_unsatisfied'
  }
  return 'camera_unavailable'
}
